import type React from 'react';
import styles from './Specifications.module.css';

interface EndpointConfigListProps {
  schemaEndpoints: any[];
  schemaProxyConfig: { endpoint_configs: Record<string, any> };
  proxyProfiles: any[];
  onUpdateEndpointProfile: (path: string, method: string, profileId: string) => void;
  onToggleMleParameter: (path: string, method: string, paramName: string, enabled: boolean) => void;
}

export const EndpointConfigList: React.FC<EndpointConfigListProps> = ({
  schemaEndpoints,
  schemaProxyConfig,
  proxyProfiles,
  onUpdateEndpointProfile,
  onToggleMleParameter,
}) => {
  if (schemaEndpoints.length === 0) {
    return (
      <div className={styles.emptyState}>
        <p>No endpoints found in this schema</p>
      </div>
    );
  }

  return (
    <div className={styles.endpointList}>
      {schemaEndpoints.map((endpoint, index) => {
        const endpointKey = `${endpoint.method} ${endpoint.path}`;
        const endpointConfig = schemaProxyConfig.endpoint_configs[endpointKey] || {};
        const mleParams = endpointConfig.mle_params || [];

        return (
          <div className={styles.endpointItem} key={index}>
            <div className={styles.endpointHeader}>
              <div>
                <span className={styles.methodBadge} data-method={endpoint.method}>
                  {endpoint.method}
                </span>
                <div className={styles.endpointPath}>{endpoint.path}</div>
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label className={styles.label}>Proxy Profile</label>
              <select
                className={styles.select}
                value={endpointConfig.proxy_profile_id || ''}
                onChange={(e) => onUpdateEndpointProfile(endpoint.path, endpoint.method, e.target.value || null)}
                data-custom-profile={
                  endpointConfig.proxy_profile_id && endpointConfig.proxy_profile_id !== '' ? 'true' : 'false'
                }
              >
                <option value="">Use Default Profile</option>
                <option value="direct">Direct (No Profile)</option>
                {proxyProfiles.map((profile) => (
                  <option key={profile.id} value={profile.id}>
                    {profile.name}
                  </option>
                ))}
              </select>
            </div>

            {endpoint.parameters.length > 0 && (
              <div>
                <label className={styles.label} style={{ marginTop: '1rem', display: 'block' }}>
                  MLE Parameters Encryption
                  <span
                    style={{
                      fontSize: '0.75rem',
                      fontWeight: 'normal',
                      marginLeft: '0.5rem',
                      color: '#666',
                    }}
                  >
                    ({endpoint.parameters.filter((p) => p.mleEncrypted).length} fields marked with x-mle-encrypted)
                  </span>
                </label>
                <div className={styles.parameterList}>
                  {endpoint.parameters.map((param, paramIndex) => (
                    <div
                      className={styles.parameterItem}
                      key={paramIndex}
                      data-mle-enabled={mleParams.includes(param.name) ? 'true' : 'false'}
                    >
                      <input
                        className={styles.checkbox}
                        type="checkbox"
                        checked={mleParams.includes(param.name)}
                        onChange={(e) =>
                          onToggleMleParameter(endpoint.path, endpoint.method, param.name, e.target.checked)
                        }
                      />
                      <span className={styles.parameterName}>
                        {param.name}
                        {param.mleEncrypted && (
                          <span
                            style={{
                              marginLeft: '0.5rem',
                              padding: '0.125rem 0.5rem',
                              background: '#22C55E',
                              color: 'white',
                              fontSize: '0.65rem',
                              borderRadius: '3px',
                              fontWeight: '600',
                              textTransform: 'uppercase',
                            }}
                          >
                            MLE
                          </span>
                        )}
                        <span
                          style={{
                            color: '#888',
                            fontSize: '0.75rem',
                            marginLeft: '0.5rem',
                          }}
                        >
                          ({param.in}
                          {param.required ? ', required' : ''})
                        </span>
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
